import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';

import * as Models from '../../models/commonModels';
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})

export class GarageVisitsService {

  constructor(private httpClient: HttpClient,
    private environment: EnvironmentService
  ) { }


  public getGaragePlaceList(Search: GarageVisitsModels.GarageVisitsPlaceSearch) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageVisitsModels.GarageVisitsPlaceListModel>(`${this.environment.getApiURL()}/garage-visits/places-list`, Search, options);
  }

  public setGarageVisitPlace(GaragePlace: Models.Request<GarageVisitsModels.GarageVisitsPlaceModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitsPlaceModel>>(`${this.environment.getApiURL()}/garage-visits/places-set`, GaragePlace, options);
  }

  public removeGarageVisitPlace(GaragePlace: Models.Request<GarageVisitsModels.GarageVisitsPlaceModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.ResponseBase>(`${this.environment.getApiURL()}/garage-visits/places-remove`, GaragePlace, options);
  }

  public getGarageVisitPlace(request: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitsPlaceModel>>(`${this.environment.getApiURL()}/garage-visits/places-get`, request, options);
  }

  public getGarageBlockedHoursList(Search: GarageVisitsModels.GarageBlockedHourSearch) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageVisitsModels.GarageBlockedListModel>(`${this.environment.getApiURL()}/garage-visits/blocked-hours-list`, Search, options);
  }

  public setGarageBlockedHour(BlockedHours: Models.Request<GarageVisitsModels.GarageBlockedModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageBlockedModel>>(`${this.environment.getApiURL()}/garage-visits/blocked-hours-set`, BlockedHours, options);
  }

  public removeGarageBlockedHour(BlockedHours: Models.Request<GarageVisitsModels.GarageBlockedModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.ResponseBase>(`${this.environment.getApiURL()}/garage-visits/blocked-hours-remove`, BlockedHours, options);
  }

  public getGarageBlockedDayList(Search: GarageVisitsModels.GarageBlockedHourSearch) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageVisitsModels.GarageBlockedListModel>(`${this.environment.getApiURL()}/garage-visits/blocked-day-list`, Search, options);
  }

  public setGarageBlockedDay(BlockedHours: Models.Request<GarageVisitsModels.GarageBlockedModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageBlockedModel>>(`${this.environment.getApiURL()}/garage-visits/blocked-day-set`, BlockedHours, options);
  }

  public removeGarageBlockedDay(BlockedHours: Models.Request<GarageVisitsModels.GarageBlockedModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<Models.ResponseBase>(`${this.environment.getApiURL()}/garage-visits/blocked-day-remove`, BlockedHours, options);
  }

  public getGarageVisits(Search: GarageVisitsModels.GarageVisitsSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<GarageVisitsModels.GarageVisitModel>> (`${this.environment.getApiURL()}/garage-visits/visit-list`, Search, options);
  }

  public getGarageMainVisits(Search: GarageVisitsModels.GarageVisitsSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<GarageVisitsModels.GarageVisitModel>>(`${this.environment.getApiURL()}/garage-visits/main-visit-list`, Search, options);
  }

  public getGarageVisit(GarageVisit: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitModel>>(`${this.environment.getApiURL()}/garage-visits/get-garage-visit`, GarageVisit, options);
  }

  public createGarageVisit(GarageVisit: Models.Request<GarageVisitsModels.GarageVisitModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitModel>>(`${this.environment.getApiURL()}/garage-visits/create-garage-visit`, GarageVisit, options);
  }

  public setGarageVisit(GarageVisit: Models.Request<GarageVisitsModels.GarageVisitModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitModel>>(`${this.environment.getApiURL()}/garage-visits/set-garage-visit`, GarageVisit, options);
  }

  public deleteGarageVisit(GarageVisit: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitModel>>(`${this.environment.getApiURL()}/garage-visits/delete-garage-visit`, GarageVisit, options);
  }

  public getPdfFilteretList(Search: GarageVisitsModels.GarageVisitsSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environment.getApiURL()}/garage-visits/visit-list-pdf`, Search, options);
  }

  public getFilteredReport(Search: GarageVisitsModels.GarageVisitsSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environment.getApiURL()}/garage-visits/visit-list-report`, Search, options);
  }

  public getPdfPlacesList(Search: GarageVisitsModels.GarageVisitsSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environment.getApiURL()}/garage-visits/visit-places-list-pdf`, Search, options);
  }

  public GetGarageVisitsCarTypeModelDictionary() {
    return this.httpClient.get<Models.Response<GarageVisitsModels.GarageVisitsCarTypeModel[]>>(`${this.environment.getApiURL()}/garage-visits/garage-visits-car-type`);
  }
}
